import { createSlice } from "@reduxjs/toolkit";

const loadFontSizesFromLocalStorage = () => {
    const storedFontSizes = localStorage.getItem("fontSizes");
    return storedFontSizes ? JSON.parse(storedFontSizes) : {};
};

const fontManagerSlice = createSlice({
    name: "fontManager",
    initialState: {
        fontSizes: loadFontSizesFromLocalStorage(),
    },
    reducers: {
        setFontSize: (state, action) => {
            const { key, size } = action.payload;
            state.fontSizes[key] = size;
            localStorage.setItem("fontSizes", JSON.stringify(state.fontSizes));
        },
        resetFontSize: (state, action) => {
            const { key, defaultSize } = action.payload;
            state.fontSizes[key] = defaultSize;
            localStorage.setItem("fontSizes", JSON.stringify(state.fontSizes));
        },
    },
});

export const { setFontSize, resetFontSize } = fontManagerSlice.actions;
export default fontManagerSlice.reducer;
